import authAxios from '../common/authAxios';

export type Method =
  | 'get'
  | 'GET'
  | 'delete'
  | 'DELETE'
  | 'head'
  | 'HEAD'
  | 'options'
  | 'OPTIONS'
  | 'post'
  | 'POST'
  | 'put'
  | 'PUT'
  | 'patch'
  | 'PATCH'
  | 'purge'
  | 'PURGE'
  | 'link'
  | 'LINK'
  | 'unlink'
  | 'UNLINK';

type ResponseType = 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream';

type FileExtension =
  | 'txt'
  | 'pdf'
  | 'doc'
  | 'docx'
  | 'xls'
  | 'xlsx'
  | 'ppt'
  | 'pptx'
  | 'jpg'
  | 'jpeg'
  | 'png'
  | 'gif'
  | 'svg'
  | 'mp3'
  | 'mp4'
  | 'wav'
  | 'avi'
  | 'mov'
  | 'zip'
  | 'tar'
  | 'gz'
  | 'rar';

export function downloadFile(
  url: string,
  method: Method,
  responseType: ResponseType,
  fileName: string,
  extension?: FileExtension,
  params?: any,
  body?: any
) {
  if (params) {
    for (const key of Object.keys(params)) {
      if (!params[key]) {
        delete params[key];
      }
    }
  }
  return authAxios({
    url,
    method,
    params,
    responseType,
    data: body,
  })
    .then((response: any) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.${extension ? extension : response.headers['content-disposition'].split('.')[1].slice(0, -1)}`);
      document.body.appendChild(link);
      link.click();
    })
}
